<template>
  <nav class="menu-container">
   <h3> <!-- <font color="#00AB39">E3路</font>-->E3路<br>深圳E3路公交车路线[常规线路]</h3>
运行时间：<br>
光明圳美总站 06:20-19:30 |<br>
深圳湾口岸公交首末站 06:50-20:00<br>
参考票价：分段收费，2-10元<br>
公交公司：深圳巴士集团股份有限公司<br>

<br><br>

光明圳美总站—深圳湾口岸<br>

<ol>
<li>光明圳美总站</li>
<li>中山七院换乘站</li>
<li>圳美路口</li>
<li>圳美市场</li>
<li>楼村小学</li>
<li>新湖派出所</li>
<li>光明红木小镇</li>
<li>雍景城西</li>
<li>红花振明路口</li>
<li>国科大医院西院区(2)</li>
<li>将石</li>
<li>将围</li>
<li>光明塘尾</li>
<li>明湖公园东</li>
<li>宏发高新产业园</li>
<li>直升机场</li>
<li>研祥科技大厦(1)</li>
<li>深圳大学</li>
<li>协和深圳医院东</li>
<li>南航公司</li>
<li>南山派出所</li>
<li>中油大厦</li>
<li>南园村东</li>
<li>城市山林东</li>
<li>南油西地铁站</li>
<li>荔秀文化街</li>
<li>南门一坊</li>
<li>北师大附中</li>
<li>后海滨路口</li>
<li>深圳湾口岸公交首末站</li>
</ol>

<br><br>

深圳湾口岸—光明圳美总站<br>

<ol>
<li>深圳湾口岸公交首末站</li>
<li>后海滨路口</li>
<li>北师大附中</li>
<li>南门一坊</li>
<li>荔秀文化街</li>
<li>南油西地铁站</li>
<li>城市山林东</li>
<li>南园村东</li>
<li>中油大厦</li>
<li>南山派出所</li>
<li>南航公司</li>
<li>协和深圳医院东</li>
<li>深圳大学</li>
<li>研祥科技大厦(1)</li>
<li>直升机场</li>
<li>宏发高新产业园</li>
<li>明湖公园东</li>
<li>光明塘尾</li>
<li>将围</li>
<li>将石</li>
<li>国科大医院西院区(1)</li>
<li>红花振明路口</li>
<li>雍景城西</li>
<li>光明红木小镇</li>
<li>新湖派出所</li>
<li>楼村小学</li>
<li>圳美市场</li>
<li>圳美路口</li>
<li>中山七院换乘站</li>
<li>光明圳美总站</li>
</ol>


    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
  </nav>
</template>

<script>
import Icon from "@/components/Icon";
export default {
  components: {
    Icon,
  },
  data() {
    return {
      items: [
        // 模板         {
        //  name: "1",
        //  title: "1",
        //  icon: "chat",
        //  exact: true,
        //  },

        // {
        //   name: "guangmingzhenmeizongzhan",
        //    title: "光明圳美总站",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "zhongshanqiyuanhuanchengzhan",
        //    title: "中山七院换乘站",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "zhenmeilukou",
        //    title: "圳美路口",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "zhenmeishichang",
        //    title: "圳美市场",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "loucunxiaoxue",
        //    title: "楼村小学",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "xinhupaichusuo",
        //    title: "新湖派出所",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "guangminghongmuxiaozhen",
        //    title: "光明红木小镇",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "yongjingchengxi",
        //    title: "雍景城西",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "honghuazhenminglukou",
        //    title: "红花振明路口",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "guokedayiyuanxiyuanqu2",
        //    title: "国科大医院西院区(2)",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "jiangshi",
        //    title: "将石",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "jiangwei",
        //    title: "将围",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "guangmingtangwei",
        //    title: "光明塘尾",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "minghugongyuandong",
        //    title: "明湖公园东",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "hongfagaoxinchanyeyuan",
        //    title: "宏发高新产业园",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "zhishengjichang",
        //    title: "直升机场",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "yanxiangkejidasha1",
        //    title: "研祥科技大厦(1)",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "shenzhendaxue",
        //    title: "深圳大学",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "xieheshenzhenyiyuandong",
        //    title: "协和深圳医院东",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "nanhanggongsi",
        //    title: "南航公司",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "nanshanpaichusuo",
        //    title: "南山派出所",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "zhongyoudasha",
        //    title: "中油大厦",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "nanyuancundong",
        //    title: "南园村东",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "chengshishanlindong",
        //    title: "城市山林东",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "nanyouxidetiezhan",
        //    title: "南油西地铁站",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "lixiuwenhuajie",
        //    title: "荔秀文化街",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "nanmenyifang",
        //    title: "南门一坊",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "beishidafuzhong",
        //    title: "北师大附中",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "houhaibinlukou",
        //    title: "后海滨路口",
        //   // icon: "chat",
        //   exact: true,
        // },
        // {
        //   name: "shenzhenwankouangongjiaoshoumozhan",
        //    title: "深圳湾口岸公交首末站",
        //   // icon: "chat",
        //   exact: true,
        // },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(67, 47, 221);
    }
  }
}
//ol 列表数字改为圆圈  
ol {
  counter-reset: section;
  list-style: none;
}

li {
  margin: 0 0 10px 0;
  line-height: 25px;
}

li:before {
  content: counter(section);
  counter-increment: section;
  display: inline-block;
  width: 25px;
  height: 25px;
  margin: 0 10px 0 0;
  border: 1px solid #228B22;  //绿色，同左边主导航一样颜色 #228B22
  border-radius: 100%;
  text-align: center;
}
</style>





